<template>
	<div class="rmp-details-item" :class="inline ? 'd-flex' : 'd-flex flex-column'">
		<rmp-text tag="span" type="body-large" :class="inline ? '' : 'mb-1'"
				  :color="colors.grey.darken1">{{ title }}</rmp-text>
		<span v-if="inline" class="mr-3">: </span>
		<slot>
			<rmp-text tag="span" :type="bold ? 'body-large-bold' : 'body-large'"
							   :class="[appendInline ? 'align-center' : 'justify-space-between flex-column align-start',
								   { 'align-start': bold, 'mt-4 mt-sm-0': !dense }]"
							   class="align-sm-center d-flex flex-sm-row flex-wrap"
							   :style="{ gap: appendInline ? '8px' : '25px' }">
				<span>{{ value }}</span>
				<slot name="append"></slot>
			</rmp-text>
		</slot>
	</div>
</template>

<script setup lang="ts">
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import { useColors } from "@rmp/core/composables/useColors";
import { i18n } from "@rmp/core/plugins";
import { computed } from "vue";
import { isNil } from "lodash";

const { colors } = useColors();

interface Props {
	title: string;
	value?: string | number | null;
	inline?: boolean;
	bold?: boolean;
	appendInline?: boolean;
	dense?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	inline: false
});

const value = computed(() => isNil(props.value) ? i18n.tc("details.values.missingData") : props.value);

</script>

<style scoped lang="less">
.rmp-details-item {
	& + & {
		margin-top: 16px !important;
	}
}
</style>
